import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { resetPassword } from '../actions';
import ResetPassword from './ResetPassword';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var authentication = _ref.authentication;
  var match = _ref2.match;
  return {
    oneTimeLoginHash: match.params.hash,
    userIdentity: match.params.userIdentity,
    status: authentication.status
  };
};
export default withRouter(connect(mapStateToProps, {
  resetPassword: resetPassword
})(ResetPassword));